import { useEffect, useRef } from "react";
import { invalidateAll } from "../services/locationCache.js";

// One collection reload per media event, not one fetch per tile. Visible
// polling/focus also picks up another editor's changes without navigation.
export function useRecordPhotoRefresh(refresh) {
  const latest = useRef(refresh);
  latest.current = refresh;
  useEffect(() => {
    let queued = false;
    const load = () => {
      if (queued || document.visibilityState === "hidden") return;
      queued = true;
      invalidateAll();
      Promise.resolve().then(() => latest.current()).finally(() => { queued = false; });
    };
    const events = ["places:location-media-changed", "places:market-media-changed", "focus"];
    events.forEach(event => window.addEventListener(event, load));
    const interval = setInterval(load, 60000);
    return () => { clearInterval(interval); events.forEach(event => window.removeEventListener(event, load)); };
  }, []);
}
